import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { ApiService } from "../../../services/api.service";

@Component({
  selector: 'app-header-main',
  templateUrl: './header-main.component.html',
  styleUrls: ['./header-main.component.scss'],
})
export class HeaderMainComponent implements OnInit {
  snowflakes: number[] = [];
  constructor(
    public api: ApiService,

  ) {
    this.generateSnowflakes(200);
  }

  ngOnInit() { }

  generateSnowflakes(count: number): void {
    this.snowflakes = Array.from({ length: count }, () => Math.floor(Math.random() * 60) + 1);
  }

}
